/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row3_ChatgptInputs */

const en_mk_cmp_row3_chatgpt = /** @type {(inputs: Mk_Cmp_Row3_ChatgptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None`)
};

const id_mk_cmp_row3_chatgpt = /** @type {(inputs: Mk_Cmp_Row3_ChatgptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada`)
};

/**
* | output |
* | --- |
* | "None" |
*
* @param {Mk_Cmp_Row3_ChatgptInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row3_chatgpt = /** @type {((inputs?: Mk_Cmp_Row3_ChatgptInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row3_ChatgptInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row3_chatgpt(inputs)
	return en_mk_cmp_row3_chatgpt(inputs)
});